import React, { useState, useEffect } from 'react'
import Layout from '../../../components/Admin/Layout'
import Subtitle from '../../../components/Admin/Subtitle'
import Loading from '../../../components/shared/Loading'
import Item from '../../../components/Admin/Item'
import AdminService from '../../../services/AdminServices'
import MessageModal from '../../../components/shared/MessageModal'
import CustomSelect from '../../../components/shared/CustomSelect'
import HomeSvg from '../../../../assets/images/home.svg'
// import GeoSvg from '../../../../assets/images/geo.svg'
import IdIcon from '../../../../assets/images/id-icon.svg'
import PlusSvg from '../../../../assets/images/plus-red.svg'
import EditSvg from '../../../../assets/images/edit-red.svg'
import DeleteSvg from '../../../../assets/images/delete-red.svg'
// import dummyData from './data'
import './Ubications.scss'
import ModalForm from '../../../components/Admin/ModalForm'
import SimpleModal from '../../../components/shared/MessageModal'
import helperAdmin from '../../../utils/helperAdmin'
import { validateLat, validateLong } from '../../../utils/regexValidator'

function Ubications() {

  const [data, setData] = useState([])
  const [initialData, setInitialData] = useState([])
  const [loading, setLoading] = useState(false)
  // const [selectedProvider, setProvider] = useState('')
  const [openModalForm, setModalForm] = useState(false)
  const [openModalFormUbi, setModalFormUbi] = useState(false)
  const [modalWarning, setModalWarning] = useState(false)
  const [openMessage, setOpenMessage] = useState(false);
  const [openMessageUbi, setOpenMessageUbi] = useState(false);
  const [error, setError] = useState({})
  const [operator, setOperator] = useState('Todos')
  const [operators, setOperators] = useState([])
  const [ubication, setUbication] = useState({
    id: '',
    name: '',
    address: '',
    lat: '',
    long: '',
    code:'',
    places: []
  })
  const [place, setPlace] = useState({
    id: '',
    name: '',
    description: '',
  })

  const clearUbication = () => {
    setUbication({
      id: '',
      name: '',
      address: '',
      lat: '',
      long: '',
      places: []
    })
    setError({})
  }

  const clearPlace = () => {
    setPlace({
      id: '',
      name: '',
      description: '',
    })
    setError({})
  }

  async function fetchData () {
    try {
      setLoading(true)
      const pickPoints = await AdminService.getPickUpPoints()
      setInitialData(formatData(pickPoints))
      if(operator) {
        console.log('filtrando por: ', operator, formatData(pickPoints))
        filterData(operator, formatData(pickPoints))
      } else {
        setData(formatData(pickPoints))
      }
      setLoading(false)
    } catch(e) {
      setLoading(false)
    }
  }

  async function fetchOperators () {
    try {
      setLoading(true)
      const operators = await AdminService.getOperators()
      setOperators([{label: 'Todos', value: 'Todos'}, ...formatOperators(operators)])
      setLoading(false)
    } catch(e) {
      setLoading(false)
    }
  }

  const formatOperators = data => {
    return data.map(d => {
      d.label = d.name
      d.value = d.id
      return d
    })
  }

  const formatData = data => {
    return data.map(d => {
      d.name = d.title
      d.lat = d.latitude
      d.long = d.longitude
      d.places = []
      return d
    })
  }

  useEffect(() => {
    fetchData()
    fetchOperators()
    // eslint-disable-next-line
  }, [])

  const filterData = (operatorId, data) => {
    const dataToFilter = data ? data : initialData;
    if(operatorId === 'Todos') setData(dataToFilter);
    else setData(dataToFilter.filter(d => d.operatorId === operatorId))
    setOperator(operatorId)
  }

  async function fetchPlacesByUbication (ubicationId) {
    try {
      setLoading(true)
      const places = await AdminService.getPlace(ubicationId)
      let newData = initialData
      for(const d of newData) {
        if(d.id === ubicationId) {
          d.places = places
        }
      }
      setInitialData(newData)
      setLoading(false)
    } catch(e) {
      console.log(e)
      setLoading(false)
    }
  }

  const renderItems = () => {
    return data.map(d => (
      <Item
        key={d.id}
        onClickEdit={() => {setModalForm(true); setUbication(d) }}
        onClickDelete={() => {setOpenMessage(true); setUbication(d)}}
        fetchPlaces={(ubicationId) => fetchPlacesByUbication(ubicationId)}
        isFetching
        ubicationId={d.id}
        details={<Detail data={d.places} ubicationId={d.id} />}>
        <div className='ubication-item'>
          <div className='item-name'>
            <p className='ubic-name'>{d.name}</p>
            <p className='ubic-code'>{d.id}</p>
          </div>
          <div className='item-local'>
            <div className='item-address'>
              <img src={HomeSvg} alt='direccion' />
              <p>{d.address}</p>
            </div>
            <div className='item-geo'>
              <img src={IdIcon} alt='localizacion' />
              <p>{d.code}</p>
            </div>
          </div>
        </div>
      </Item>
    ))
  }

  const Detail = ({ data, ubicationId }) => {
    return (
      <div className='detail-container'>
        <div className='detail-head'>
          <p>Ubicaciones</p>
          <div className='detail-add' onClick={() => {setModalFormUbi(true); setPlace({...place, ubicationId })}}>
            <img src={PlusSvg} alt='agregar' />
          </div>
        </div>
        {renderDetailItems(data, ubicationId)}
      </div>
    )
  }

  const renderDetailItems = (data, ubicationId) => {
    return data.map((p,i) => (
      <div key={i} className='detail-body'>
        <div className='detail-info'>
          <h2>{p.name}</h2>
          <p>{p.description}</p>
        </div>
        <div className='detail-buttons'>
          <div className='edit-place' onClick={() => {setModalFormUbi(true); setPlace({...p, ubicationId})}}>
            <img src={EditSvg} alt='editar' />
          </div>
          <div className='remove-place' onClick={() => {setOpenMessageUbi(true); setPlace({...p, ubicationId})}}>
            <img src={DeleteSvg} alt='eliminar' />
          </div>
        </div>
      </div>
    ))
  }

  const handleChangePlace = (evt, name) => {
    let value = evt.target ? evt.target.value : evt;
    const key = evt.target ? evt.target.name : name;
    console.log(value, key);
    setPlace({ ...place, [key]: value });
    let newError = {...error}
    if(newError[key]) newError = helperAdmin.removeKey(key, newError);
    setError(newError)
  }

  const handleChangeUbication = (evt, name) => {
    let value = evt.target ? evt.target.value : evt;
    const key = evt.target ? evt.target.name : name;
    // console.log(/^-?\d*\.?\d{0,9}$/g.test(value))
    if((key === 'lat' && value !== '') && !validateLat(value)) return
    if((key === 'long' && value !== '') && !validateLong(value)) return
    console.log(value, key);
    setUbication({ ...ubication, [key]: value });
    let newError = {...error}
    if(newError[key]) newError = helperAdmin.removeKey(key, newError);
    setError(newError)
  }

  const handleCreateUbication = async () => {
    // Validar si campos vacios
    console.log('CREAR UBICACION')
    const newError = helperAdmin.validateUbication(ubication);
    console.log('newError', newError);

    console.log('ubication', ubication);
    setError(newError);
    // RETORNAR para parar la ejecucion
    if(Object.entries(newError).length !== 0 && newError.constructor === Object) return;
    // if(!ubication.id) setData([...data, { ...ubication, id: Math.floor(Math.random() * 9000000000) }]);
    // else{
    //   const ubicationIndex = data.findIndex(d => d.id === ubication.id)
    //   let newData = [...data];
    //   newData[ubicationIndex] = ubication;
    //   setData(newData);
    // }
    // clearUbication();
    // setModalForm(false)

    if(ubication.id) {
      try {
        setLoading(true)
        await AdminService.updatePickUpPoint(ubication.id, ubication.name, ubication.lat, ubication.long, ubication.address, ubication.code)
        setLoading(false)
        clearUbication()
        setModalForm(false)
        fetchData()
      } catch(e) {
        setLoading(false)
        setModalWarning(true)
      }
    } else {
      try {
        setLoading(true)
        await AdminService.createPickUpPoints(operator, ubication.name, ubication.lat, ubication.long, ubication.address, ubication.code)
        setLoading(false)
        clearUbication()
        setModalForm(false)
        fetchData()
      } catch(e) {
        setLoading(false)
        setModalWarning(true)
      }

    }
  }

  const handleCreatePlace = async () => {
    // Validar si campos vacios
    console.log('hola')
    const newError = helperAdmin.validatePlace(place);
    setError(newError);
    // RETORNAR para parar la ejecucion
    if(Object.entries(newError).length !== 0 && newError.constructor === Object) return;

    // const ubicationIndex = data.findIndex(d => d.id === place.ubicationId);
    // const newData = [...data];
    // if(!place.id) newData[ubicationIndex].places.push({...place, id: Math.floor(Math.random() * 9999)});
    // else{
    //   const placeIndex = newData[ubicationIndex].places.findIndex(p => p.id === place.id)
    //   newData[ubicationIndex].places[placeIndex] = place;
    // }

    if(place.id) {
      try {
        setLoading(true)
        await AdminService.updatePlace(place.id, place.name, place.description)
        setLoading(false)
        clearPlace()
        setModalFormUbi(false)
        fetchPlacesByUbication(place.ubicationId)
      } catch(e) {
        console.log(e)
        setLoading(false)
        setModalWarning(true)
      }
    } else {
      try {
        setLoading(true)
        await AdminService.createPlace(place.ubicationId, place.name, place.description)
        setLoading(false)
        clearPlace()
        setModalFormUbi(false)
        fetchPlacesByUbication(place.ubicationId)
      } catch(e) {
        console.log(e)
        setLoading(false)
        setModalWarning(true)
      }
    }


    // setData(newData);
    // setModalFormUbi(false)
    // clearPlace();
  }

  const handleDeleteUbication = async () => {
    // const ubications = data.filter(d => d.id !== ubication.id);
    // setData(ubications);
    // clearUbication();
    // setOpenMessage(false);
    try {
      setLoading(true)
      await AdminService.deletePickUpPoint(ubication.id)
      setLoading(false)
      clearUbication()
      setOpenMessage(false)
      fetchData()
    } catch(e) {
      setLoading(false)
      setModalWarning(true)
    }
  }

  const handleDeletePlace = async () => {
    // let ubicationIndex = data.findIndex(d => d.id === place.ubicationId);
    // let newData = [...data];
    // const newPlaces = newData[ubicationIndex].places.filter(p => p.id !== place.id)
    // newData[ubicationIndex].places = newPlaces;
    // setData(newData);
    // clearPlace();
    // setOpenMessageUbi(false);

    try {
      setLoading(true)
      await AdminService.deletePlace(place.id)
      setLoading(false)
      clearPlace()
      setOpenMessageUbi(false)
      fetchPlacesByUbication(place.ubicationId)
    } catch(e) {
      setLoading(false)
      setModalWarning(true)
    }
  }

  return (
    <Layout>
      <MessageModal visible={modalWarning} closeModal={() => setModalWarning(false)} message='No se pudo conectar al servicio. Revise su conexión' type={1} />
      <ModalForm
        title='Punto de retiro'
        visible={openModalForm}
        closeModal={() => {setModalForm(false); clearUbication()}}
        onClickBtn1={() => { setModalForm(false); clearUbication() }}
        onClickBtn2={handleCreateUbication}

        updating={ubication.id}
        name={ubication.name}
        address={ubication.address}
        lat={1}
        long={1}
        code={ubication.code}
        onChange={handleChangeUbication}
        error={error}
      />
      <ModalForm
        title='Ubicación'
        visible={openModalFormUbi}
        closeModal={() => {setModalFormUbi(false); clearPlace() }}
        onClickBtn1={() => { setModalFormUbi(false); clearPlace()}}
        onClickBtn2={handleCreatePlace}

        updating={place.id}
        name={place.name}
        description={place.description}
        onChange={handleChangePlace}
        error={error}
      />
      <SimpleModal
        visible={openMessage}
        closeModal={() => {setOpenMessage(false); clearUbication()}}
        message='¿Desea eliminar el punto de retiro seleccionado?'
        type={3}
        txtBtn1='Cancelar'
        txtBtn2='Eliminar'
        onClickBtn1={() => {setOpenMessage(false); clearUbication()}}
        onClickBtn2={handleDeleteUbication}
      />
      <SimpleModal
        visible={openMessageUbi}
        closeModal={() => {setOpenMessageUbi(false); clearPlace()}}
        message='¿Desea eliminar la ubicación seleccionada?'
        type={3}
        txtBtn1='Cancelar'
        txtBtn2='Eliminar'
        onClickBtn1={() => {setOpenMessageUbi(false); clearPlace()}}
        onClickBtn2={handleDeletePlace}
      />
      <Loading visible={loading} />
      <div className='ubications-container'>
        <Subtitle
          text='Puntos de retiro'
          onClick={() => setModalForm(true)}
          disabled={!operator || operator === 'Todos'}
        />
        <div className='ubications-combo'>
          <CustomSelect
            value={operator}
            handleChange={e => filterData(e.target.value)}
            options={operators}
          />
        </div>
        <div className='ubications-items'>
          {renderItems()}
        </div>
      </div>
    </Layout>
  )
}

export default Ubications
